import { inject } from '@angular/core';
import { TranslationService } from '@lib/i18n/data-access';
import { ErrorMessages } from '@platform-workspace/design-system';
import { MinMaxLengthValidatorCallbackParams, VALIDATION_MESSAGES, ValidatorsKeys } from '@shared/utils/validators';

export const getErrorMessagesForZipcodeInput = (translationService: TranslationService): ErrorMessages => {
  return {
    [ValidatorsKeys.Required]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Required]),
    [ValidatorsKeys.MinLength]: ({ requiredLength }: MinMaxLengthValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.MinLength], { value: requiredLength });
    },
    [ValidatorsKeys.MaxLength]: ({ requiredLength }: MinMaxLengthValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.MaxLength], { value: requiredLength });
    },
    [ValidatorsKeys.Pattern]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Zipcode]),
  };
};

export const getErrorMessagesForTelegramInput = (translationService: TranslationService): ErrorMessages => {
  return {
    [ValidatorsKeys.Required]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Required]),
    [ValidatorsKeys.MaxLength]: ({ requiredLength }: MinMaxLengthValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.MaxLength], { value: requiredLength });
    },
    [ValidatorsKeys.MinLength]: ({ requiredLength }: MinMaxLengthValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.MinLength], { value: requiredLength });
    },
    [ValidatorsKeys.Pattern]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Telegram]),
  };
};

export const getUsernameErrorMessages = (): ErrorMessages => {
  const translationService = inject(TranslationService);

  return {
    [ValidatorsKeys.Required]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Required]),
    [ValidatorsKeys.MinLength]: ({ requiredLength }: MinMaxLengthValidatorCallbackParams) =>
      translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.MinLength], { value: requiredLength }),
    [ValidatorsKeys.MaxLength]: ({ requiredLength }: MinMaxLengthValidatorCallbackParams) =>
      translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.MaxLength], { value: requiredLength }),
    [ValidatorsKeys.ForbiddenSymbols]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.ForbiddenSymbols]),
    [ValidatorsKeys.UsernameExists]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.UsernameExists]),
  };
};

export const getErrorMessagesForReasonInput = (translationService: TranslationService): ErrorMessages => {
  return {
    [ValidatorsKeys.Required]: translationService.translate('operator.services.reasonErrorMessage'),
    [ValidatorsKeys.MaxLength]: ({ requiredLength }: MinMaxLengthValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.MaxLength], { value: requiredLength });
    },
  };
};
